import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FatClassTipi } from '../interfaces/fat-class-tipi';
import { FatDoctoC } from '../interfaces/fat-docto-c';
import { from, Observable, of, throwError } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { environment } from 'environments/environment';
import { map, catchError } from 'rxjs/operators';
import { JwtAuthService } from './auth/jwt-auth.service';


@Injectable({
  providedIn: 'root'
})

export class FatClassTipiService {


  readonly path = '/fatclasstipi';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }


  getFatClassTipiId(id: number): Observable<FatClassTipi> {
    return this.http.get<FatClassTipi>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getFatClassTipiNcm(ncm: string): Observable<FatClassTipi> {
    return this.http.get<FatClassTipi>(`${this.jwtAuthService.apiUrl + this.path}/ncm/${ncm}`);
  }


  saveOrUpdateFatClass(fatClass: FatClassTipi): Observable<FatClassTipi> {
    return this.http.put<FatClassTipi>(`${this.jwtAuthService.apiUrl + this.path}`, fatClass);
  }

  deleteFatClassTip(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }


  getFatClassTipPage(page?: number, size?: number, order?: string, direction?: string, desativado?: boolean): Observable<PageResult<FatClassTipi>> {
    return this.http.get<PageResult<FatClassTipi>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}`
      + `&order=${order}&direction=${direction}&desativado=${desativado}`);
  }

  getFatClassTipPageSearch(page?: number, size?: number,
    search?: string, order?: string, direction?: string, desativado?: boolean): Observable<PageResult<FatClassTipi>> {
    return this.http.get<PageResult<FatClassTipi>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}&search=${search}`
      + `&order=${order}&direction=${direction}&desativado=${desativado}`);
  }

}
